import { render, staticRenderFns } from "./advisoryItem.vue?vue&type=template&id=6687f3e7&scoped=true&"
import script from "./advisoryItem.vue?vue&type=script&lang=js&"
export * from "./advisoryItem.vue?vue&type=script&lang=js&"
import style0 from "./advisoryItem.vue?vue&type=style&index=0&id=6687f3e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687f3e7",
  null
  
)

export default component.exports